/**
 * @generated SignedSource<<5aad7f5364f82e7ffbeae52ea8540080>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type singleFlag_softwareReleasesVersionDetailIssueList$data = {
  readonly mostRelevantDisplayName: string;
  readonly mostRelevantEnabled: boolean;
  readonly mostRelevantRolloutPercentage: number | null | undefined;
  readonly " $fragmentType": "singleFlag_softwareReleasesVersionDetailIssueList";
};
export type singleFlag_softwareReleasesVersionDetailIssueList$key = {
  readonly " $data"?: singleFlag_softwareReleasesVersionDetailIssueList$data;
  readonly " $fragmentSpreads": FragmentRefs<"singleFlag_softwareReleasesVersionDetailIssueList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "singleFlag_softwareReleasesVersionDetailIssueList",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "mostRelevantDisplayName"
      },
      "action": "THROW",
      "path": "mostRelevantDisplayName"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "mostRelevantEnabled"
      },
      "action": "THROW",
      "path": "mostRelevantEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "mostRelevantRolloutPercentage"
    }
  ],
  "type": "DevOpsSummarisedFeatureFlags"
};

(node as any).hash = "5843724954a8e05bf3074b304ff85341";

export default node;
